/**
 * Enum representing possible product measurement units.
 */
export enum ProductMeasure {
  /** Measurement in grams */
  Grams = "Grams",
  
  /** Measurement in kilograms */
  Kilograms = "Kgs",
  
  /** Measurement in liters */
  Liters = "Ltr(s)",
  
  /** Measurement by quantity */
  Quantity = "Qty"
}
